import React, { useState, useEffect } from "react";
import MeetingTable from "../../../Components/layouts/StudentCourse/MeetingTable";
import { Modal } from "../../../Components/share/modal/Modal";
import MeetingAnswerModal from "../../../Components/layouts/StudentCourse/MeetingAnswerModal";
import MeetingsFileModal from "../../../Components/layouts/StudentCourse/MeetingsFileModal";
import useFetch from "../../../Hooks/useFetch";
import MainPagination from "../../../Components/share/Pageination/MainPagination";

function Meeting() {
    const [sessions, setSessions] = useState("");
    const [sessionFiles, setSessionFiles] = useState("");
    const [sessionHomeworks, setSessionHomeworks] = useState("");
    const [selectedSession, setSelectedSession] = useState();

    const [modalbtn, setModalbtn] = useState(false);
    const [modalbtnfile, setModalbtnfile] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const header = [{ title: "نام جلسه" }, { title: "زمان جلسه" }];

    console.log(sessionHomeworks);

    const getSessions = useFetch({
        method: "GET",
        url: `BootCampSessionService/11/sessions`,
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setSessions,
    });
    //Todo : id bootcamp dynamic she

    const getSessionFiles = useFetch({
        method: "GET",
        url: `BootCampSessionFilesService/${selectedSession}/session_files`,
        noHeader: false,
        setter: setSessionFiles,
    });

    const getSessionHomeworks = useFetch({
        method: "GET",
        url: `BootCampSessionHomeWorkService/${selectedSession}/session_homeworks`,
        noHeader: false,
        setter: setSessionHomeworks,
    });

    useEffect(() => {
        if (selectedSession) {
            getSessionFiles.reFetch();
            getSessionHomeworks.reFetch();
        }
    }, [selectedSession]);

    return (
        <div>
            <div className="flex justify-between items-center">
                <h4 className="text-[2rem] text-purple-dark font-bold">
                    اطلاعات جلسات بوت کمپ
                </h4>
            </div>
            {sessions && (
                <>
                    <MeetingTable
                        list={sessions?.results}
                        homeworks={sessionHomeworks?.results}
                        showModal={setModalbtn}
                        show={setModalbtnfile}
                        setSelectedSession={setSelectedSession}
                        header={header}
                    >
                        <Modal show={modalbtn}>
                            <MeetingAnswerModal
                                homeworks={sessionHomeworks?.results}
                                setHomeworks={setSessionHomeworks}
                                setSelectedSession={setSelectedSession}
                                close={setModalbtn}
                            />
                        </Modal>
                    </MeetingTable>
                    <MainPagination
                        pagination={pagination}
                        setPagination={setPagination}
                        data={sessions?.results}
                        pageSize={sessions?.page_count}
                        className=" mt-[3rem]"
                    />
                </>
            )}

            <Modal show={modalbtnfile}>
                <MeetingsFileModal
                    files={sessionFiles?.results}
                    setSelectedSession={setSelectedSession}
                    setFiles={setSessionFiles}
                    close={setModalbtnfile}
                />
            </Modal>
        </div>
    );
}

export default Meeting;
